<template>
    <div class="calendar-overview-root">
        <Header :label="$t('calendar.header')" overlap="small" />

        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <WidgetModule slot="right" />
            <div slot="center">
                <SectionHeader slot="center" style="position:relative">
                    <Breadcrumb slot="left" :trace="breadcrumb"
                /></SectionHeader>
                <div v-if="!hasCalendar" slot="Center">
                    <NoContent :caption="$t('calendar.noCalendar')"></NoContent>
                    <BaseButton
                        id="backButton"
                        class="w-100"
                        variant="primary"
                        style="margin-top:20px;"
                        @click="handleGoBack"
                    >
                        {{ $t('calendar.goBackBtn') }}
                    </BaseButton>
                </div>
                <div v-else-if="!calendarViewReady" slot="Center">
                    <NoContent :caption="$t('calendar.calendarNotReady')"></NoContent>
                    <BaseButton
                        id="backButton"
                        class="w-100"
                        variant="primary"
                        style="margin-top:20px;"
                        @click="handleGoBack"
                    >
                        {{ $t('calendar.goBackBtn') }}
                    </BaseButton>
                </div>
                <Paper v-else tall class="calendar-mycalendar-wrapper">
                    <div v-if="!numUpcomingAppointments()" class="calendar-noUpcoming-wrapper">
                        <img class="empty-image" :src="emptyImage" />
                        <h6 class="text-center">
                            {{ $t('calendar.noUpcomingAppointments') }}
                        </h6>
                        <h6 class="text-center">
                            {{ $t('calendar.noUpcomingAppointmentsPleaseBook') }}
                        </h6>
                        <BaseButton
                            id="bookButton"
                            class="w-100"
                            variant="primary"
                            @click="handleBookClick"
                        >
                            {{ $t('calendar.bookAppointment') }}
                        </BaseButton>
                        <BaseButton
                            id="bookButton"
                            class="w-100"
                            variant="text-primary"
                            :no-outline="false"
                            @click="handleAboutClick"
                        >
                            {{ $t('calendar.aboutAppointments.button') }}
                        </BaseButton>
                    </div>
                    <div v-else>
                        <Calendar :date-click-callback="dateClick" />
                        <div class="calendar-cal-btn-wrapper">
                            <BaseButton
                                id="bookButton"
                                class="w-100"
                                variant="primary"
                                @click="handleBookClick"
                            >
                                {{ $t('calendar.bookAnotherAppointment') }}
                            </BaseButton>
                        </div>
                    </div>
                </Paper>
            </div>
            <div slot="center">
                <Paper :header="$t('calendar.attendedAppointments')" tall>
                    <AttendedAppointments v-for="i in 10" :key="i" />
                </Paper>
            </div>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import FeaturedResource from '~/components/smart/FeaturedResource';
import NoContent from '~/components/miscellaneous/NoContent';
import WidgetModule from '~/components/smart/WidgetModule.vue';

import DialogService from '~/services/DialogService';
import CalendarService from '~/services/CalendarService';

import Paper from '~/components/builders/Paper';

import URLS from '~/URLS';
import i18n from '~/i18n';

// Assets

import EmptySvg from '~/assets/img/empty.svg';
import Calendar from '~/components/builders/Calendar';
import Breadcrumb from '../../../shared/Breadcrumb';
import SectionHeader from '~/components/layouts/SectionHeader';

export default {
    name: 'CalendarOverview',
    components: {
        Breadcrumb,
        Calendar,
        Paper,
        Header,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        SectionHeader,
        NoContent,
        WidgetModule,
    },
    data: () => ({
        emptyImage: EmptySvg,
        breadcrumb: [
            {
                exact: true,
                text: i18n.t('calendar.myCalendar'),
                to: URLS.calendar,
            },
        ],
        calendarViewReady: false,
        calendarService: new CalendarService(),
    }),
    computed: {},
    methods: {
        handleAboutClick() {
            DialogService.openCalendarAboutDialog();
        },
        numUpcomingAppointments() {
            return 1;
        },
        handleBookClick() {
            this.$router.push(this.$URLS.calendar.concat(this.$URLS.book));
        },
        dateClick(year, month, date) {
            // TODO: Get events by date in params. pass these to DialogService.
            let formattedDate = `${date}/${month + 1} - ${year}`; // TODO: Proper format
            DialogService.openAppointmentsDateDialog(formattedDate);
        },
        hasCalendar() {
            return this.calendarService.hasCalendar().then(result => {
                this.hasCalendar = result;
            });
        },
        handleGoBack() {
            this.$router.back();
        },
    },
    mounted() {},
};
</script>

<style scoped>
.calendar-mycalendar-wrapper {
    /*padding-bottom: 20px;*/
}
.calendar-noUpcoming-wrapper {
    width: 50%;
    margin: auto;
}
.calendar-cal-btn-wrapper {
    padding-top: 20px;
    padding-bottom: 20px;
    margin: auto;
    width: 50%;
}
.empty-image {
    width: 200px;
    height: 200px;
    object-fit: scale-down;
    display: block;
    margin: auto;
}
</style>
